import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";
import Editor from "./ProviderEditor";
import service from "./ProviderService";

export default {
  mixins: [AppLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.companyName;
    }
  }
};
